export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6887.30223059.jpg";